const bmdtLanguage = (info =  "Showing _START_ - _END_ out of _MAX_") => ({
    searchPlaceholder: "Search",
    lengthMenu: "_MENU_",
    info: info,
    search: '',
    emptyTable: "No data available in table",
    paginate: {
        previous: '<span class="fas fa-angle-left"></span>',
        next: '<span class="fas fa-angle-right"></span>'
    }
});

const bmdtConfiguration = (data, columns, columnDefs, displayLength = 5, rowReorder = false) => {
    let lengthMenu = [5, 10, 15, 20, 25, 50, 75, 100];
    if (!lengthMenu.includes(displayLength)) {
        lengthMenu = [...lengthMenu, displayLength].sort((a, b) => a - b);
    }
    return {
        dom: '<"d-flex justify-content-between" <"#dt-heading.d-flex justify-content-start align-items-center" > <"d-flex justify-content-end align-items-center" <"#dt-extra"> pfl <"#dt-export"> > > t ',
        displayLength: displayLength,
        paging: true,
        lengthMenu: lengthMenu,
        pagingType: "simple",
        autoWidth: false,
        rowReorder: rowReorder,
        draw: 1,
        stateSave: true,        
        columns,
        columnDefs,
        language: bmdtLanguage(),
        data,
        order: [[0, "asc"]],
        createdRow: function(row, data) {
            if (data.id) {
                $(row).attr('data-rowid', data.id);
            }
        }        
    };    
};

const bmdtConfigurationSimple = (data, columns, columnDefs, displayLength = 10) => {
    let lengthMenu = [10, 25, 50, 75, 100];
    if (!lengthMenu.includes(displayLength)) {
        lengthMenu = [...lengthMenu, displayLength].sort((a, b) => a - b);
    }
    return {
        dom: '<"row" t <"#dt-heading.d-flex mt-2 justify-content-start align-items-center" > <"d-flex mt-2 justify-content-end align-items-center" pfl  > >',
        displayLength: displayLength,
        paging: true,
        lengthMenu: lengthMenu,
        pagingType: "simple",
        autoWidth: false,
        columns,
        columnDefs,
        language: bmdtLanguage(),
        data,
        order: [[0, "asc"]]
    };
};

const bmdtConfigurationSimpleReorderable = (data, columns, columnDefs, displayLength = 10) => {
    let lengthMenu = [10, 25, 50, 75, 100];
    if (!lengthMenu.includes(displayLength)) {
        lengthMenu = [...lengthMenu, displayLength].sort((a, b) => a - b);
    }

    return {
        dom: '<"row" t <"#dt-heading.d-flex mt-2 justify-content-start align-items-center" > <"d-flex mt-2 justify-content-end align-items-center" pfl  > >',
        displayLength: displayLength,
        paging: true,
        lengthMenu: lengthMenu,
        pagingType: "simple",
        autoWidth: false,
        rowReorder: true,
        draw: 1,
        stateSave: true,
        columns,
        columnDefs,
        language: bmdtLanguage(),
        data,
        order: [[0, "asc"]]
    };
};

export {
    bmdtConfiguration,
    bmdtConfigurationSimple,
    bmdtConfigurationSimpleReorderable
};